import React from 'react';
import './MainContent.css';
import { Link } from 'react-router-dom';
import image from '../../Images/MainContent/Engine Cover.png';
import textlogo from '../../Images/Logo/IceGemsText2.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';

const stats = [
  { value: 'Best Efficiency', label: 'Small 2-Stroke' },
  { value: 'First 100%', label: 'Balanced Piston Engine' },
  { value: 'Licensing', label: 'Models and Options' },
  { value: 'Siemens', label: 'CFD Validated' },
];

interface HeroProps {
  onClick: () => void;
}

const MainContent: React.FC<HeroProps> = ({ onClick }) => {
  return (
    <div className='hero-wrapper'>
      <div className='hero-content'>
        <div className='hero-text'>
          <img src={textlogo} alt="ICE GEMS" className='hero-logo' loading="lazy" />
          <h1 className='hero-headline'>
            A New Generation<br />
            <span className='hero-headline-accent'>Of Engines</span>
          </h1>
          <p className='hero-subheadline'>
             Interested in licensing our technology, evaluating potential applications, or simply learning more? We’d be glad to hear from you.
          </p>
          <div className='hero-cta-row'>
            <Link to="/request-info" className='hero-btn-primary'>
              <FontAwesomeIcon icon={faPaperPlane} />
              Start the Conversation
            </Link>
            <button onClick={onClick} className='hero-btn-secondary'>
              <FontAwesomeIcon icon={faYoutube} />
              About Us
            </button>
          </div>
          <Link to="/ourstory" className='hero-text-link'>
            Explore Our Technology <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>

        <div className='hero-image-col'>
          <div className='hero-image-wrapper'>
            <img src={image} alt="ICE GEMS Engine" className='hero-engine-img' loading="lazy" />
            <div className='hero-image-glow' />
          </div>
        </div>
      </div>

      <div className='hero-stats-bar'>
        {stats.map((stat, i) => (
          <div key={i} className='hero-stat'>
            <span className='hero-stat-value'>{stat.value}</span>
            <span className='hero-stat-label'>{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainContent;
